export const SPAIN_PROVINCE_FILES: Record<string, string> = {
  '01': 'ALAVA',
  '02': 'ALBACETE',
  '03': 'ALICANTE',
  '04': 'ALMERIA',
  '05': 'AVILA',
  '06': 'BADAJOZ',
  '07': 'BALEARES',
  '08': 'BARCELONA',
  '09': 'BURGOS',
  '10': 'CACERES',
  '11': 'CADIZ',
  '12': 'CASTELLON',
  '13': 'CIUDAD_REAL',
  '14': 'CORDOBA',
  '15': 'A_CORUNA',
  '16': 'CUENCA',
  '17': 'GIRONA',
  '18': 'GRANADA',
  '19': 'GUADALAJARA',
  '20': 'GUIPUZCOA',
  '21': 'HUELVA',
  '22': 'HUESCA',
  '23': 'JAEN',
  '24': 'LEON',
  '25': 'LLEIDA',
  '26': 'LA_RIOJA',
  '27': 'LUGO',
  '28': 'MADRID',
  '29': 'MALAGA',
  '30': 'MURCIA',
  '31': 'NAVARRA',
  '32': 'OURENSE',
  '33': 'ASTURIAS',
  '34': 'PALENCIA',
  '35': 'LAS_PALMAS',
  '36': 'PONTEVEDRA',
  '37': 'SALAMANCA',
  '38': 'TENERIFE',
  '39': 'CANTABRIA',
  '40': 'SEGOVIA',
  '41': 'SEVILLA',
  '42': 'SORIA',
  '43': 'TARRAGONA',
  '44': 'TERUEL',
  '45': 'TOLEDO',
  '46': 'VALENCIA',
  '47': 'VALLADOLID',
  '48': 'VIZCAYA',
  '49': 'ZAMORA',
  '50': 'ZARAGOZA',
  '51': 'CEUTA',
  '52': 'MELILLA',
};
